import getPreviewToken from './get-preview-token';

function setPreviewCacheHeader(app) {
  if (!getPreviewToken(app) || !app.ctx.res) return;

  app.ctx.res.setHeader('Cache-Control', 'max-age=0');
}

export default setPreviewCacheHeader;
